// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__387KQ","emails":"CreateEditClinics_emails__7sTZa","emailTagLabel":"CreateEditClinics_emailTagLabel__12fen"};